import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  get_all_public_event_links_data_action,
  view_mentor_profile_info_action,
} from "../../../redux/_actions";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function MentorProfile(props) {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState({});
  const [publicEvents, setPublicEvents] = useState(null);
  const [userPrimarySkills, setUserPrimarySkills] = useState([]);
  const [jobTitle, setJobTitle] = useState(null);

  //get data from redux
  const { viewMentorProfileInfo } = useSelector(
    (state) => state.view_mentor_profile_data_reducer
  );

  const { publicEventLinksData } = useSelector(
    (state) => state.get_all_public_event_links_data_reducer
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    let id = params?.id;
    let jobTitle = location?.state && location.state?.jobTitle;
    if (jobTitle) setJobTitle(jobTitle);
    if (id) getMentorInfo(id);
  }, []);

  useEffect(() => {
    if (viewMentorProfileInfo?.data !== undefined) {
      setUserData(viewMentorProfileInfo?.data);
    }
  }, [viewMentorProfileInfo]);

  useEffect(() => {
    if (viewMentorProfileInfo?.data) {
      getUserPrimarySkills(viewMentorProfileInfo?.data);
    }
  }, [viewMentorProfileInfo]);

  useEffect(() => {
    if (viewMentorProfileInfo?.data !== undefined) {
      if (
        viewMentorProfileInfo?.data &&
        viewMentorProfileInfo.data?.mentor_details.hash_id !== null
      ) {
        getPublicEvents(viewMentorProfileInfo?.data?.mentor_details?.hash_id);
      }
    }
  }, [viewMentorProfileInfo]);

  useEffect(() => {
    if (publicEventLinksData?.data) {
      let results = publicEventLinksData?.data;
      if (results && results.length > 0) {
        let data = results[0];
        setPublicEvents(data);
      }
    }
  }, [publicEventLinksData]);

  const getMentorInfo = async (id) => {
    setLoading(true);
    await dispatch(view_mentor_profile_info_action(id));
    setLoading(false);
  };
  const getPublicEvents = async (id) => {
    await dispatch(get_all_public_event_links_data_action(id));
  };
  const getUserPrimarySkills = (data) => {
    let skills =
      data?.mentor_profile_details && data.mentor_profile_details?.skills;

    let results = skills && skills.filter((item) => item?.is_primary === true);

    if (results.length > 0) setUserPrimarySkills(results);
    else setUserPrimarySkills(skills);
  };
  const onScheduleInterviewClick = async (id) => {
    if (publicEvents?.event_details) {
      navigate(
        `/schedule-interview?event_link=${
          publicEvents?.event_details && publicEvents.event_details?.hash_id
        }`
      );
    } else
      showWarningMessage("Mentor does not have a public event to schedule.");
  };

  const onNavigateBack = () => {
    navigate(-1);
  };
  const onShareProfileClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/view-mentor-profile/${
          userData?.mentor_details &&
          userData.mentor_details?.hash_id
        }`  
      : `${process.env.REACT_APP_DEV_ROOT_URL}/view-mentor-profile/${
          userData?.mentor_details &&
          userData.mentor_details?.hash_id
        }`;
    window.navigator.clipboard.writeText(url);

    showSuccessMessage(`Url copied ${url}`);
  };
  return {
    loading,
    jobTitle,
    userData,
    publicEvents,
    userPrimarySkills,
    onScheduleInterviewClick,
    onNavigateBack,
    onShareProfileClick
  };
}
export default MentorProfile;
